import TransactionService from '@/services/transaction'

export default {
  setTransactionProduct ({commit}, data) {
    commit('SET_TRANSACTION_PRODUCT', data)
    return Promise.resolve(data)
  },
  setTransactionPayment ({commit}, data) {
    commit('SET_TRANSACTION_PAYMENT', data)
  },
  getHistory({commit}, params = {}) {
    return new Promise((resolve, reject) => {
      TransactionService.getHistory({
        params,
        headers: {
          'Authorization': localStorage.token
        }
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(e => reject(e))
    })
  },
  getTypeTransaction ({commit}, params = {}) {
    return new Promise((resolve, reject) => {
      TransactionService.getTypeTransaction({
        params,
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          commit('SET_TYPE_TRANSACTION', response.data.data)
          resolve(response.data.data)
        })
        .catch(e => reject(e))
    })
  },
  makeTransaction ({commit}, payload = {}) {
    return new Promise((resolve, reject) => {
      TransactionService.makeTransaction(payload, {
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          commit('SET_HISTORY_TRANSACTION', response.data)
          resolve(response.data)
        })
        .catch(e => reject(e))
    })
  },
  removeTransactionTypes({commit}) {
    commit('REMOVE_TRANSACTION_TYPES');
  }
};